import React from 'react'
import {
  change as changeFieldValue, formValueSelector, reduxForm
} from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {selecionarReservaParaCriada, alterarFormaPagamentoReservaCriada} from '../../actions/reserva/selecionarReservaParaCriar';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import { paisesDDI } from '../../util/constantsUtil';
import QRCode from 'qrcode.react';
import ReactTooltip from 'react-tooltip';

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
    <div className="row cabecalho-desktop">
      <div className="col-lg-2 col-xl-2">Origem</div>
      <div className="col-lg-2 col-xl-2">Destino</div>
      <div className="col-lg-2 col-xl-2">Partida</div>
      <div className="col-lg-2 col-xl-2">Prestador</div>
      <div className="col-lg-2 col-xl-2">Ponto de embarque</div>
      <div className="col-lg-2 col-xl-2">Tipo de passagem</div>
    </div>
  </div>
);

export class ResumoCompra extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      mensagem: {
        tipo: '',
        texto: ''
      },
      criarReserva: null,
      urlImagem: '',
      formasPagamentoDisplay: []
    };
  }

  UNSAFE_componentWillMount () {
    this.montarParametroReserva()
  }

  retornarGarantiaPrecoUuidPorBloqueioPoltronasTemporario(passageiro) {
    return this.props.bloqueioPoltronasTemporario.bloqueios
            .filter(it => it.poltronaId === passageiro.poltronaId).map(it => it.uuid).shift();
  }

  montarParametroReserva () {
    const reservas = [];
    let cont = 0;

    this.props.passageirosIda.forEach((pass) => {
      let paisDDI = paisesDDI.find(it => it.id === pass.ddi)
      if (pass.siglaPais) {
        paisDDI = paisesDDI.find(it => it.sigla === pass.siglaPais)
      }      
      reservas.push(
        {
          idReserva: this.recuperarIdReservaRemarcacao(cont),
          passageiroDto: Object.assign({}, pass, { ddi: paisDDI.ddi, siglaPais: paisDDI.sigla }),
          sentido: 'IDA',
          poltronaId: pass.poltronaId,
          desconto: this.props.formasPagamento && this.props.formasPagamento.length ? Number(this.props.formasPagamento[0].descontoIda) === 0 ? null : Number(this.props.formasPagamento[0].descontoIda)  : null,
          acrescimoPassagem: this.props.formasPagamento && this.props.formasPagamento.length ? Number(this.props.formasPagamento[0].acrescimoPassagemIda) : 0,
          itinerarioId: this.props.viagemIda.idItinerario,
          idCidadeOrigem: this.props.origem.id,
          idCidadeDestino: this.props.destino.id,
          valor: this.props.viagemIda.preco,
          embarque: this.props.viagemIda.embarque,
          garantiaPrecoUuid: this.retornarGarantiaPrecoUuidPorBloqueioPoltronasTemporario(pass),
          tarifaSeguro: pass.vendaSeguro ? this.props.viagemIda.tarifaSeguro : 0.00          
        }
      );
      cont += 1;
    });

    if (this.props.passageirosVolta.length > 0) {
      this.props.passageirosVolta.forEach((pass) => {
        let paisDDI = paisesDDI.find(it => it.id === pass.ddi)
        if(pass.siglaPais) {
          paisDDI = paisesDDI.find(it => it.sigla === pass.siglaPais)
        }
        reservas.push(
          {
            idReserva: this.recuperarIdReservaRemarcacao(cont),
            passageiroDto: Object.assign({}, pass, { ddi: paisDDI.ddi, siglaPais: paisDDI.sigla }),
            poltronaId: pass.poltronaId,
            sentido: 'VOLTA',
            itinerarioId: this.props.viagemVolta.idItinerario,
            desconto: this.props.formasPagamento && this.props.formasPagamento.length ? Number(this.props.formasPagamento[0].descontoVolta) === 0 ? null : Number(this.props.formasPagamento[0].descontoVolta) : null,
            acrescimoPassagem: this.props.formasPagamento && this.props.formasPagamento.length ? Number(this.props.formasPagamento[0].acrescimoPassagemVolta) : 0,
            idCidadeOrigem: this.props.destino.id,
            idCidadeDestino: this.props.origem.id,
            valor: this.props.viagemVolta.preco,
            embarque: this.props.viagemVolta.embarque,
            garantiaPrecoUuid: this.retornarGarantiaPrecoUuidPorBloqueioPoltronasTemporario(pass),
            tarifaSeguro: pass.vendaSeguro ? this.props.viagemVolta.tarifaSeguro : 0.00            
          }
        );
        cont += 1;
      });
    }

    const valorTotal = this.props.calcularValorTotal();
    const formasBase = this.props.formasPagamento;
    const formasPagamentoNormalizadas = formasBase && formasBase.length > 0
      ? [{ ...formasBase[0], valor: valorTotal }]
      : [{ tipo: 'Dinheiro', codigoTipo: 'DINHEIRO', base64Comprovante: '', numeroComprovante: '', valor: valorTotal, quantidadeParcelas: 1 }];
    this.props.adicionarFormasPagamento(formasPagamentoNormalizadas);
    this.setState({ formasPagamentoDisplay: formasPagamentoNormalizadas });


    // Garantir que dadosPagamento existe e tem ddiComprador
    const ddiComprador = this.props.dadosPagamento && this.props.dadosPagamento.ddiComprador ? this.props.dadosPagamento.ddiComprador : null
    let paisDDI = ddiComprador ? paisesDDI.find(it => it.id === ddiComprador) : null
    if (!paisDDI) {
      paisDDI = paisesDDI.find(it => it.sigla === 'BR') || paisesDDI[0]
    }
    
    const criarReserva = {
      ehVendaEmMassa: this.props.ehVendaEmMassa,
      tipoVeiculo: this.props.viagemIda.tipoVeiculo,
      cidadeOrigem: this.props.origem.id,
      cidadeDestino: this.props.destino.id,
      empresaId: this.props.empresaSelecionada.id,
      embarque: this.props.embarque,
      reservas,
      pontoVenda: 'TERMINAL',
      formasPagamentoDto: formasPagamentoNormalizadas,
      // campos da venda via Stone Connect (maquininha POS), elevados do FormaPagamentoDto para o
      // nível raiz do comando -- só fazem sentido quando a forma de pagamento é STONE_CONNECT (ver
      // plano de integração Connect Stone, seção 7.2); undefined nos demais casos, sem efeito
      numeroSerieDispositivoStone: formasPagamentoNormalizadas[0] ? formasPagamentoNormalizadas[0].numeroSerieDispositivoStone : undefined,
      modoStoneConnect: formasPagamentoNormalizadas[0] ? formasPagamentoNormalizadas[0].modoStoneConnect : undefined,
      tipoPagamentoStoneConnect: formasPagamentoNormalizadas[0] ? formasPagamentoNormalizadas[0].tipoPagamentoStoneConnect : undefined,
      parcelasStoneConnect: formasPagamentoNormalizadas[0] ? formasPagamentoNormalizadas[0].parcelasStoneConnect : undefined,
      dadosCompradorDto: this.props.dadosPagamento ? Object.assign({}, this.props.dadosPagamento, { ddi: paisDDI.ddi, siglaPais: paisDDI.sigla }) : null,
      usuarioDirecionado: this.props.usuarioSelecionadoVendaDirecionada && this.props.usuarioSelecionadoVendaDirecionada.id ? this.props.usuarioSelecionadoVendaDirecionada.id : null,
      pedidoId: null,
      habilitadoZerarValorMultaRemarcacao: this.props.habilitadoZerarValorMultaRemarcacao

    };
        
    this.props.selecionarReservaParaCriada(criarReserva);
  }

  recuperarIdReservaRemarcacao (index) {
    if (this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0) {
      return this.props.reservasSelecionadasRemarcacao[index].id
    }
    return null
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  limparFormulario () {
    this.props.reset('formReserva');
    this.limparMensagem();
  }

  ehpagamentoTEF(){
    return this.props.pagamentoTEF
  }

  ehPagamentoLink() {
    return this.props.criarReserva &&
      this.props.criarReserva.formasPagamentoDto &&
      this.props.criarReserva.formasPagamentoDto.some(f => f.codigoTipo === 'LINK_PAGAMENTO');
  }
  
  ehPagamentoCieloEcommerce() {
    return this.props.criarReserva &&
      this.props.criarReserva.formasPagamentoDto &&
      this.props.criarReserva.formasPagamentoDto.some(f => f.codigoTipo === 'CIELO_ECOMMERCE');
  }

  ehPagamentoSicoob() {
    return this.props.criarReserva &&
      this.props.criarReserva.formasPagamentoDto &&
      this.props.criarReserva.formasPagamentoDto.some(f => f.codigoTipo === 'SICOOB');
  }

  ehPagamentoStoneConnect() {
    return this.props.criarReserva &&
      this.props.criarReserva.formasPagamentoDto &&
      this.props.criarReserva.formasPagamentoDto.some(f => f.codigoTipo === 'STONE_CONNECT');
  }

  alteraFormaPagamento(formaPagamento) {
    this.props.alterarFormaPagamentoReservaCriada(formaPagamento).then(() => {
          this.props.pagarPedido(formaPagamento);
        })
  }

  alteraFormaPagamentoLink(formaPagamento) {
    this.props.alterarFormaPagamentoReservaCriada(formaPagamento).then(() => {
          this.props.pagarPedidoLink(formaPagamento);
        })
  }

  alteraFormaPagamentoCieloEcommerce(formaPagamento) {
    this.props.alterarFormaPagamentoReservaCriada(formaPagamento).then(() => {
          this.props.pagarPedidoCieloEcommerce(formaPagamento);
        })
  }

  alteraFormaPagamentoSicoob(formaPagamento) {
    this.props.alterarFormaPagamentoReservaCriada(formaPagamento).then(() => {
          this.props.pagarPedidoSicoob(formaPagamento);
        })
  }

  alteraFormaPagamentoStoneConnect(formaPagamento) {
    this.props.alterarFormaPagamentoReservaCriada(formaPagamento).then(() => {
          this.props.pagarPedidoStoneConnect(formaPagamento);
        })
  }

  loadBotoes (forma) {
    if (forma.situacao === 'APROVADO') {
      return <i className="material-icons" style={{ color: '#4caf50', fontSize: '22px' }}>check_circle</i>
    }
    if (this.ehPagamentoLink()) {
      return (
        <button className="vx-summary-pay-action-btn"
                disabled={forma.habilitado === false || this.props.linkPagamentoGerado}
                onClick={() => this.alteraFormaPagamentoLink(forma)}>
          Gerar Link
        </button>
      )
    }   
    if (this.ehPagamentoCieloEcommerce()) {
      return (
        <button className="vx-summary-pay-action-btn"
                disabled={forma.habilitado === false || this.props.cieloEcommerceAguardando || !!this.props.cieloEcommerceCopiaECola}
                onClick={() => this.alteraFormaPagamentoCieloEcommerce(forma)}>
          Gerar QR Code PIX
        </button>
      )
    }
    if (this.ehPagamentoSicoob()) {
      return (
        <button className="vx-summary-pay-action-btn"
                disabled={forma.habilitado === false || this.props.sicoobAguardando || !!this.props.sicoobCopiaECola}
                onClick={() => this.alteraFormaPagamentoSicoob(forma)}>
          Gerar QR Code PIX
        </button>
      )
    }
    if (this.ehPagamentoStoneConnect()) {
      return (
        <>
          <button className="vx-summary-pay-action-btn"
                  disabled={forma.habilitado === false || this.props.stoneConnectAguardando}
                  onClick={() => this.alteraFormaPagamentoStoneConnect(forma)}>
            Enviar para Maquininha
          </button>
          {this.props.stoneConnectAguardando && (
            <>
              <button className="vx-summary-pay-action-btn"
                      style={{ marginLeft: 8, background: '#e53935' }}
                      onClick={() => this.props.cancelarPedidoStoneConnect()}>
                Cancelar
              </button>
              <span style={{ marginLeft: 4 }}>
                <a data-tip data-for="tt-cancelar-stone-connect">
                  <i className="material-icons" style={{ color: '#888', fontSize: 16, verticalAlign: 'middle' }}>help</i>
                </a>
                <ReactTooltip className="tooltip-ut" id="tt-cancelar-stone-connect" type="dark" effect="solid">
                  <div style={{ maxWidth: 260 }}>
                    Cancela o envio à maquininha enquanto o pagamento ainda não foi confirmado.
                    Isso NÃO cancela e NÃO estorna automaticamente as cobranças que já foram
                    capturadas e aprovadas.
                  </div>
                </ReactTooltip>
              </span>
            </>
          )}
        </>
      )
    }
    return (
      <button className="vx-summary-pay-action-btn"
              disabled={forma.habilitado === false}
              onClick={() => this.alteraFormaPagamento(forma)}>
        Pagar
      </button>
    )
  }

  exibirFormasPagamento () {
    if (!this.props.criarReserva.formasPagamentoDto || this.props.criarReserva.formasPagamentoDto.length === 0) {
      return ''
    }
    return (
      <div className="vx-summary-payment">
        <div className="vx-summary-payment-header">
          <i className="material-icons">payment</i>
          <span className="vx-summary-payment-title">Formas de Pagamento</span>
        </div>
        <div className="vx-summary-payment-body">
          <div className="vx-summary-pay-list">
            <div className="vx-summary-pay-list-header">
              <span>Tipo</span>
              <span>Valor</span>
              <span>Parcelas</span>
              <span>Nº Comprovante</span>
              <span>Situação</span>
            </div>
            {this.state.formasPagamentoDisplay.map((forma, index) => (
              <div key={index} className="vx-summary-pay-list-row">
                <span data-label="Tipo">{forma.tipo}</span>
                <span data-label="Valor">{forma.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                <span data-label="Parcelas">{forma.quantidadeParcelas ? forma.quantidadeParcelas : '-'}</span>
                <span data-label="Nº Comprovante">{forma.numeroComprovante ? forma.numeroComprovante : '-'}</span>
                <span data-label="Situação">{(this.ehpagamentoTEF() || this.ehPagamentoLink() || this.ehPagamentoCieloEcommerce() || this.ehPagamentoSicoob() || this.ehPagamentoStoneConnect()) ? this.loadBotoes(forma) : '-'}</span>
              </div>
            ))}
          </div>

          {this.ehpagamentoTEF() && (
            <div className="vx-summary-tef-alert">
              <i className="material-icons">info</i>
              <span>Clique no botão <strong>PAGAR</strong> para realizar o pagamento via TEF. Assim que o pagamento for finalizado e confirmado, você será redirecionado automaticamente para a tela de impressão do bilhete.</span>
            </div>
          )}

          {this.ehPagamentoLink() && !this.props.linkPagamentoGerado && (
            <div className="vx-summary-link-alert">
              <i className="material-icons">link</i>
              <span>Clique no botão <strong>GERAR LINK</strong> para criar o link de pagamento Cielo. Compartilhe o link com o cliente e aguarde a confirmação do pagamento.</span>
            </div>
          )}

          {this.ehPagamentoLink() && this.props.linkPagamentoGerado && this.props.linkPagamentoUrl && (
            <div className="vx-summary-qr-card">
              <div className="vx-summary-qr-title">
                <i className="material-icons">check_circle</i>
                Link de Pagamento gerado!
              </div>
              <QRCode value={this.props.linkPagamentoUrl} size={180} />
              <p className="vx-summary-qr-url">{this.props.linkPagamentoUrl}</p>
              <div className="vx-summary-qr-actions">
                <button className="vx-summary-qr-copy-btn"
                        onClick={() => navigator.clipboard.writeText(this.props.linkPagamentoUrl)}>
                  <i className="material-icons" style={{ fontSize: '16px' }}>content_copy</i>
                  Copiar Link
                </button>
                <a className="vx-summary-qr-whatsapp-btn"
                   href={`https://wa.me/?text=${encodeURIComponent('Link de pagamento: ' + this.props.linkPagamentoUrl)}`}
                   target="_blank"
                   rel="noopener noreferrer">
                  <i className="material-icons" style={{ fontSize: '16px' }}>chat</i>
                  WhatsApp
                </a>
              </div>
              <div className="vx-summary-waiting">
                <i className="material-icons">sync</i>
                Aguardando confirmação do pagamento...
              </div>
            </div>
          )}

          {this.ehPagamentoCieloEcommerce() && !this.props.cieloEcommerceCopiaECola && (
            <div className="vx-summary-tef-alert">
              <i className="material-icons">info</i>
              <span>Clique no botão <strong>GERAR QR CODE PIX</strong> para gerar o QR Code PIX via Cielo E-commerce. Aguarde o cliente concluir o pagamento.</span>
            </div>
          )}

          {this.ehPagamentoCieloEcommerce() && this.props.cieloEcommerceCopiaECola && (
            <div className="vx-summary-qr-card">
              <div className="vx-summary-qr-title">
                <i className="material-icons">check_circle</i>
                QR Code PIX gerado!
              </div>
              <QRCode value={this.props.cieloEcommerceCopiaECola} size={180} />
              <p className="vx-summary-qr-url">{this.props.cieloEcommerceCopiaECola}</p>
              <div className="vx-summary-qr-actions">
                <button className="vx-summary-qr-copy-btn"
                        onClick={() => navigator.clipboard.writeText(this.props.cieloEcommerceCopiaECola)}>
                  <i className="material-icons" style={{ fontSize: '16px' }}>content_copy</i>
                  Copiar Código PIX
                </button>
              </div>
              <div className="vx-summary-waiting">
                <i className="material-icons">sync</i>
                Aguardando confirmação do pagamento...
              </div>
            </div>
          )}

          {this.ehPagamentoSicoob() && !this.props.sicoobCopiaECola && (
            <div className="vx-summary-tef-alert">
              <i className="material-icons">info</i>
              <span>Clique no botão <strong>GERAR QR CODE PIX</strong> para gerar o QR Code PIX via Sicoob. Aguarde o cliente concluir o pagamento.</span>
            </div>
          )}

          {this.ehPagamentoSicoob() && this.props.sicoobCopiaECola && (
            <div className="vx-summary-qr-card">
              <div className="vx-summary-qr-title">
                <i className="material-icons">check_circle</i>
                QR Code PIX gerado!
              </div>
              <QRCode value={this.props.sicoobCopiaECola} size={180} />
              <p className="vx-summary-qr-url">{this.props.sicoobCopiaECola}</p>
              <div className="vx-summary-qr-actions">
                <button className="vx-summary-qr-copy-btn"
                        onClick={() => navigator.clipboard.writeText(this.props.sicoobCopiaECola)}>
                  <i className="material-icons" style={{ fontSize: '16px' }}>content_copy</i>
                  Copiar Código PIX
                </button>
              </div>
              <div className="vx-summary-waiting">
                <i className="material-icons">sync</i>
                Aguardando confirmação do pagamento...
              </div>
            </div>
          )}

          {this.ehPagamentoStoneConnect() && !this.props.stoneConnectAguardando && (
            <div className="vx-summary-tef-alert">
              <i className="material-icons">info</i>
              <span>Clique no botão <strong>ENVIAR PARA MAQUININHA</strong> para realizar o pagamento via Connect Stone. Aguarde o cliente concluir o pagamento na maquininha.</span>
            </div>
          )}

          {this.ehPagamentoStoneConnect() && this.props.stoneConnectAguardando && (
            <div className="vx-summary-waiting">
              <i className="material-icons">sync</i>
              {this.props.stoneConnectStatus || 'Aguardando o cliente concluir o pagamento na maquininha...'}
            </div>
          )}
        </div>
      </div>
    )
  }

  exibirResumo (origem, destino, viagem, sentido) {
    return (
      <div className="vx-summary-trip">
        <div className="vx-summary-trip-header">
          <div className="vx-summary-trip-header-left">
            <i className="material-icons">directions_bus</i>
            <span className="vx-summary-trip-sentido">{sentido}</span>
          </div>
          <div className="vx-summary-trip-route">
            <span>{origem.nome}</span>
            <i className="material-icons">arrow_forward</i>
            <span>{destino.nome}</span>
          </div>
        </div>
        <div className="vx-summary-trip-grid">
          <div className="vx-summary-trip-field">
            <span className="vx-summary-field-label">Partida</span>
            <span className="vx-summary-field-value">{viagem.dataPartida} às {viagem.horaPartida}</span>
          </div>
          <div className="vx-summary-trip-field">
            <span className="vx-summary-field-label">Prestador</span>
            <span className="vx-summary-field-value">{viagem.nomePrestador || '-'}</span>
          </div>
          <div className="vx-summary-trip-field">
            <span className="vx-summary-field-label">Embarque</span>
            <span className="vx-summary-field-value">{viagem.embarque}</span>
          </div>
          <div className="vx-summary-trip-field">
            <span className="vx-summary-field-label">Veículo</span>
            <span className="vx-summary-field-value">{viagem.descricaoTipoVeiculo}</span>
          </div>
        </div>
        <div className="vx-summary-pax-grid">
          {this.exibirPassageiros(sentido, viagem.pedagio)}
        </div>
      </div>
    )
  }

  exibirPassageiros (sentido, pedagio) {
    return this.props.criarReserva.reservas
      .filter(it => it.sentido === sentido)
      .map((reserva, idx) => (
        <div key={reserva.poltronaId || idx} className="vx-summary-pax-card">
          <div className="vx-summary-pax-header">
            <i className="material-icons">person</i>
            <span className="vx-summary-pax-name">{reserva.passageiroDto.nome}</span>
            <span className="vx-summary-pax-seat">
              <i className="material-icons">airline_seat_recline_normal</i>
              {reserva.passageiroDto.numeroPoltrona}
            </span>
          </div>
          <div className="vx-summary-pax-body">
            <div className="vx-summary-pax-field">
              <span className="vx-summary-field-label">CPF</span>
              <span className="vx-summary-field-value">{reserva.passageiroDto.cpfPassageiro}</span>
            </div>
            <div className="vx-summary-pax-field">
              <span className="vx-summary-field-label">Documento</span>
              <span className="vx-summary-field-value">{reserva.passageiroDto.documentoComFoto}</span>
            </div>
            <div className="vx-summary-pax-field">
              <span className="vx-summary-field-label">Tipo Documento</span>
              <span className="vx-summary-field-value">{reserva.passageiroDto.tipoDocumento}</span>
            </div>
            <div className="vx-summary-pax-field">
              <span className="vx-summary-field-label">Tipo Emissão</span>
              <span className="vx-summary-field-value">{reserva.passageiroDto.tipoEmissao}</span>
            </div>
            <div className="vx-summary-pax-field">
              <span className="vx-summary-field-label">Valor</span>
              <span className="vx-summary-field-value vx-orange">
                {Number(reserva.passageiroDto.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </span>
            </div>
            <div className="vx-summary-pax-field">
              <span className="vx-summary-field-label">Taxa de embarque</span>
              <span className="vx-summary-field-value">
                {reserva.passageiroDto.taxaEmbarque && !this.props.ehGratuidadeTotal(reserva.passageiroDto.tipoEmissao)
                  ? Number(reserva.passageiroDto.taxaEmbarque).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                  : 'R$ 0,00'}
              </span>
            </div>
            <div className="vx-summary-pax-field">
              <span className="vx-summary-field-label">Pedágio</span>
              <span className="vx-summary-field-value">
                {pedagio && !this.props.ehGratuidadeTotal(reserva.passageiroDto.tipoEmissao)
                  ? Number(pedagio).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                  : 'R$ 0,00'}
              </span>
            </div>
            <div className="vx-summary-pax-field">
              <span className="vx-summary-field-label">Seguro</span>
              <span className="vx-summary-field-value">
                {reserva.tarifaSeguro && !this.props.ehGratuidadeTotal(reserva.passageiroDto.tipoEmissao)
                  ? Number(reserva.tarifaSeguro).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                  : 'R$ 0,00'}
              </span>
            </div>
            {this.exibirCrianca(reserva.passageiroDto.criancaDto)}
          </div>
        </div>
      ))
  }

  exibirCrianca (crianca) {
    if (!crianca) return '';
    return (
      <div className="vx-summary-child">
        <div className="vx-summary-child-title">
          <i className="material-icons">child_care</i>
          Criança de colo
        </div>
        <div className="vx-summary-pax-field">
          <span className="vx-summary-field-label">Nome</span>
          <span className="vx-summary-field-value">{crianca.nome}</span>
        </div>
        <div className="vx-summary-pax-field">
          <span className="vx-summary-field-label">CPF</span>
          <span className="vx-summary-field-value">{crianca.cpfCrianca}</span>
        </div>
        <div className="vx-summary-pax-field">
          <span className="vx-summary-field-label">Data de Nascimento</span>
          <span className="vx-summary-field-value">{crianca.dtNascimentoCrianca}</span>
        </div>
        <div className="vx-summary-pax-field">
          <span className="vx-summary-field-label">Documento com Foto</span>
          <span className="vx-summary-field-value">{crianca.documentoCriacaComFoto}</span>
        </div>
      </div>
    )
  }

  render () {
    if (!this.props.criarReserva) {
      return ''
    }
    return (
      <div className="vx-summary-container">
        {this.exibirResumo(this.props.origem, this.props.destino, this.props.viagemIda, 'IDA')}
        {this.props.viagemVolta && this.exibirResumo(this.props.destino, this.props.origem, this.props.viagemVolta, 'VOLTA')}
        {this.exibirFormasPagamento()}
      </div>
    )
  }
}

export function

mapStateToProps (state) {
  return {
    embarqueVolta: formValueSelector('formReserva')(state, 'embarqueVolta'),
    embarqueIda: formValueSelector('formReserva')(state, 'embarqueIda'),
    usuariosEmpresa: state.usuariosEmpresa,
    ehVendaEmMassa: state.ehVendaEmMassa,
    viagemIda: state.viagemIda,
    viagemVolta: state.viagemVolta,
    poltronasSelecionadas: state.poltronasSelecionadas,
    origem: state.origem,
    destino: state.destino,
    empresaSelecionada: state.empresaSelecionada,
    passageirosVolta: state.passageirosVolta,
    dadosPagamento: state.dadosPagamento,
    formasPagamento: state.formasPagamento,
    passageirosIda: state.passageirosIda,
    criarReserva: state.criarReserva,
    reservasSelecionadasRemarcacao: state.remarcacao.reservasSelecionadas,
    bloqueioPoltronasTemporario: state.bloqueioPoltronasTemporario,
    usuarioSelecionadoVendaDirecionada: state.usuarioSelecionado
  }
}


export const
  mapDispatchToProps = dispatch => (
    bindActionCreators({
      changeFieldValue,
      selecionarReservaParaCriada,
      adicionarFormasPagamento,
      alterarFormaPagamentoReservaCriada
    }, dispatch)
  );

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'formReserva',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(
    ResumoCompra
  )
);
